import { render, staticRenderFns } from "./PromoListView.vue?vue&type=template&id=c6198370&"
import script from "./PromoListView.vue?vue&type=script&lang=js&"
export * from "./PromoListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6198370')) {
      api.createRecord('c6198370', component.options)
    } else {
      api.reload('c6198370', component.options)
    }
    module.hot.accept("./PromoListView.vue?vue&type=template&id=c6198370&", function () {
      api.rerender('c6198370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promo/PromoListView.vue"
export default component.exports